// extracted by mini-css-extract-plugin
export default {"h2":"Participants_h2__ejawo","table":"Participants_table__cBs1L","link":"Participants_link__p2iIw","td":"Participants_td__FnS8V","content":"Participants_content__bczKy"};